import {DistrictList} from "./DistrictList";
import {DistrictEdit} from "./DistrictEdit";
import {DistrictCreate} from "./DistrictCreate";

export default {
    list: DistrictList,
    create: DistrictCreate,
    edit: DistrictEdit
};
